/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$defineProperties = _interopDefault(require('babel-runtime/core-js/object/define-properties'));
var _Object$keys = _interopDefault(require('babel-runtime/core-js/object/keys'));
var __ol__ = _interopDefault(require('openlayers'));
var throttleTime = require('rxjs/operator/throttleTime');
var Vue = _interopDefault(require('vue'));
var mixin = require('../mixin');
var rxExt = require('../rx-ext');
var assert = require('../util/assert');
var minilo = require('../util/minilo');
var mergeDescriptors = _interopDefault(require('../util/multi-merge-descriptors'));
var vueHelpers = require('../util/vue-helpers');
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));

var Graticule = __ol__.Graticule;
var props = {
  maxLines: {
    type: Number,
    default: 100
  },
  targetSize: {
    type: Number,
    default: 100
  },
  showLabels: {
    type: Boolean,
    default: false
  },
  lonLabelFormatter: Function,
  latLabelFormatter: Function,
  lonLabelPosition: {
    type: Number,
    default: 0
  },
  latLabelPosition: {
    type: Number,
    default: 1
  },
  intervals: {
    type: Array,
    default: function _default() {
      return [90, 45, 30, 20, 10, 5, 2, 1, 0.5, 0.2, 0.1, 0.05, 0.01, 0.005, 0.002, 0.001];
    }
  }
};

var computed = {
  meridians: function meridians() {
    var _this = this;

    if (this.$graticule && this.rev) {
      return minilo.map(this.getMeridians(), function (meridian) {
        return _this.lineToDataProj(meridian.getCoordinates());
      });
    }

    return [];
  },
  parallels: function parallels() {
    var _this2 = this;

    if (this.$graticule && this.rev) {
      return minilo.map(this.getParallels(), function (parallel) {
        return _this2.lineToDataProj(parallel.getCoordinates());
      });
    }

    return [];
  }
};

var methods = {
  createOlObject: function createOlObject() {
    return new Graticule({
      maxLines: this.maxLines,
      targetSize: this.targetSize,
      showLabels: this.showLabels,
      strokeStyle: this._strokeStyle,
      lonLabelFormatter: this.lonLabelFormatter,
      latLabelFormatter: this.latLabelFormatter,
      lonLabelPosition: this.lonLabelPosition,
      latLabelPosition: this.latLabelPosition,
      lonLabelStyle: this._lonLabelStyle,
      latLabelStyle: this._latLabelStyle,
      intervals: this.intervals
    });
  },

  /**
   * @return {Promise} Resolves when initialization completes
   * @protected
   */
  init: function init() {
    return mixin.olCmp.methods.init.call(this);
  },

  /**
   * @return {void|Promise<void>}
   * @protected
   */
  deinit: function deinit() {
    return mixin.olCmp.methods.deinit.call(this);
  },

  /**
   * @return {Promise}
   * @protected
   */
  mount: function mount() {
    this.$map && this.$graticule.setMap(this.$map);
    this.subscribeAll();
  },

  /**
   * @return {Promise}
   * @protected
   */
  unmount: function unmount() {
    this.unsubscribeAll();
    this.$graticule.setMap(undefined);
  },
  getMeridians: function getMeridians() {
    assert.hasGraticule(this);

    return this.$graticule.getMeridians();
  },
  getParallels: function getParallels() {
    assert.hasGraticule(this);

    return this.$graticule.getParallels();
  },
  setStroke: function setStroke(stroke) {
    stroke = stroke instanceof Vue ? stroke.$style : stroke;

    if (stroke !== this._strokeStyle) {
      this._strokeStyle = stroke;
      this.scheduleRefresh();
    }
  },
  setText: function setText(text) {
    text = text instanceof Vue ? text.$style : text;

    var vm = void 0;
    if (text) {
      vm = minilo.firstEl(text[this.$options.VM_PROP]);
    }

    var vmMatcher = function vmMatcher(vnode) {
      return vnode.componentInstance && vnode.componentInstance === vm;
    };

    if (text == null && this.$slots.lon == null || Array.isArray(this.$slots.lon) && this.$slots.lon.some(vmMatcher)) {
      if (text !== this._lonLabelStyle) {
        this._lonLabelStyle = text;
        this.scheduleRefresh();
      }
    } else if (text == null && this.$slots.lat == null || Array.isArray(this.$slots.lat) && this.$slots.lat.some(vmMatcher)) {
      if (text !== this._latLabelStyle) {
        this._latLabelStyle = text;
        this.scheduleRefresh();
      }
    }
  },
  getServices: function getServices() {
    var vm = this;

    return mergeDescriptors(mixin.olCmp.methods.getServices.call(this), {
      get stylesContainer() {
        return vm;
      }
    });
  },

  /**
   * @return {Promise}
   */
  refresh: function refresh() {
    return this.recreate();
  },
  subscribeAll: function subscribeAll() {
    var _context,
        _this3 = this;

    assert.hasMap(this);

    var ft = 1000 / 60;
    var postcompose = (_context = rxExt.observableFromOlEvent(this.$map, 'postcompose'), throttleTime.throttleTime).call(_context, ft);

    this.subscribeTo(postcompose, function () {
      ++_this3.rev;
    });
  }
};

var watch = vueHelpers.makeWatchers(_Object$keys(props), function () {
  return function () {
    this.scheduleRefresh();
  };
});

var Graticule$1 = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('i', { class: _vm.$options.name, staticStyle: { "display": "none !important" } }, [_vm._t("lon"), _vm._v(" "), _vm._t("lat"), _vm._v(" "), _vm._t("stroke")], 2);
  }, staticRenderFns: [],
  name: 'vl-graticule',
  mixins: [mixin.olCmp, mixin.useMapCmp, mixin.projTransforms],
  props: props,
  computed: computed,
  methods: methods,
  watch: watch,
  stubVNode: {
    empty: false,
    attrs: function attrs() {
      return {
        class: this.$options.name
      };
    }
  },
  created: function created() {
    var _this4 = this;

    _Object$defineProperties(this, {
      $graticule: {
        enumerable: true,
        get: function get() {
          return _this4.$olObject;
        }
      },
      $map: {
        enumerable: true,
        get: function get() {
          return _this4.$services && _this4.$services.map;
        }
      },
      $view: {
        enumerable: true,
        get: function get() {
          return _this4.$services && _this4.$services.view;
        }
      }
    });
  }
};

var index = {
  Graticule: Graticule$1,
  install: function install(Vue$$1) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Graticule$1, options);

    Vue$$1.component(Graticule$1.name, Graticule$1);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/graticule/index.js
// module id = 1461
// module chunks = 1